import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import * as fromProposal from './reducers/proposal.reducer';
import {EffectsModule} from '@ngrx/effects';
import {ProposalEffects} from './effects/proposal.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromProposal.proposalFeatureKey, fromProposal.reducer),
    EffectsModule.forFeature([ProposalEffects]),
  ],
})
export class ProposalStoreModule {
}
